export default function callbackBigcommerceLoadReducer(state = {}, action) {
	switch (action.type) {
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/containers/callback-bigcommerce-load-page/reducers/index.js